import request from '@/utils/request'

// 查询大赛分类
export function getTitles (url, remark) {
  return request({
    url: url + '/actuator/child/getTitles/' + remark,
    method: 'get'
  })
}
// 查询站点管理详细
export function getSite (url, id) {
  console.log('详情', url, id)
  return request({
    url: url + '/actuator/site/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/work/index.js